import React, { useState } from "react";
import vinoth from "../img/vinoth-text.png";
import "./Header.css";
import { Link } from "react-scroll";
import Bars from "../img/bars.png";
const Header = () => {
  const mobile = window.innerWidth <= 768 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);
  return (
    <div className="header">
      <img src={vinoth} alt="" className="logo" />
      {menuOpened == false && mobile == true ? (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px",
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img
            className="bar"
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="home"
              span={true}
              smooth={true}
            >
              Home
            </Link>
          </li>
         
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Achievements"
              span={true}
              smooth={true}
            >
              Achievements
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Reasons"
              span={true}
              smooth={true}
            >
              Why Us
            </Link>
          </li>
          {/* <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Gallary"
              span={true}
              smooth={true}
            >
              Gallary
            </Link>
          </li> */}
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Classes"
              span={true}
              smooth={true}
            >
              Classes
            </Link>
          </li>

          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="About"
              span={true}
              smooth={true}
            >
              About
            </Link>
          </li>

          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="contact"
              span={true}
              smooth={true}
            >
              Contact
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
